// Canonical base URL for the public site.
// The bare apex calwaste.com only forwards (GoDaddy) and does not serve the app.
// Only https://www.calwaste.com serves the site, so every machine-readable URL
// (canonical, og:url, twitter, JSON-LD, sitemap loc, rss link/guid) must use it.
export const SITE_URL = "https://www.calwaste.com";

// Visible label only. Never use this as a URL.
export const SITE_URL_LABEL = "calwaste.com";

/** Normalize any base URL to the canonical host. */
export function normalizeSiteUrl(input?: string | null): string {
  if (!input) return SITE_URL;
  try {
    const u = new URL(input.trim());
    const host = u.hostname.toLowerCase();
    if (host === "www.calwaste.com" && u.protocol === "https:") return SITE_URL;
    if (host === "calwaste.com" || host.endsWith(".lovable.app") || host.endsWith(".lovableproject.com")) {
      return SITE_URL;
    }
    if (u.protocol !== "https:") return SITE_URL;
    return u.origin;
  } catch {
    return SITE_URL;
  }
}
